




/*-*-*-*-*-*-*-*-*-*-*-*-*-*- SignalR section   -*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/
var srCon = new signalR.HubConnectionBuilder().withUrl("/rtm").build();

srCon.start().then(function () {
    let srs = document.getElementById("sigrStatus");
    srs.className = "srs act";
    srs.title = "SignalR Server Connected";

    srCon.on("onDisconnect", function (e, data) {
        document.getElementById("sigrStatus").className = "srs fail";
    });

    //srCon.on("BroadcastMessageReceived", function (message) {
    //    const ne = document.createElement("div");
    //    ne.className = "da";    // dynamically added node
    //    ne.innerHTML = document.getElementById("envTemplate").innerHTML;
    //    ne.querySelector(".paper").innerHTML = message;
    //    document.body.appendChild(ne);

    //    setTimeout(function () {
    //        document.querySelector(".da").querySelector(".envelope").classList.add("fold");

    //        setTimeout(function () {
    //            document.querySelector(".da").remove();
    //        }, 10000);
    //    }, 3000);
    //});
    srCon.on("PageRefreshRequest", function (message) {
        //location.reload();
        //$(".tab-label").click();
    });

    srCon.on("PageReRoute", function (message) {
        window.location.href = message;
        window.location.replace(message);
    });


    srCon.on("PrivateMessageReceived", function (message) {
        const ne = document.createElement("div");
        ne.className = "da";    // dynamically added node
        ne.innerHTML = document.getElementById("envTemplate").innerHTML;
        ne.querySelector(".paper").innerHTML = message;
        document.body.appendChild(ne);
        document.querySelector(".da").querySelector(".envelope").classList.add("fold");
        //setTimeout(function () {
        //    document.querySelector(".da").querySelector(".envelope").classList.add("fold");

        //    setTimeout(function () {
        //        document.querySelector(".da").remove();
        //    }, 10000);
        //}, 3000);



        //location.reload();
    });

    //srCon.on("CloseMessageReceived", function (message) {
    //    const ne = document.createElement("div");
    //    ne.className = "da";    // dynamically added node
    //    ne.innerHTML = document.getElementById("envTemplate").innerHTML;
    //    ne.querySelector(".paper").innerHTML = message;
    //    document.body.appendChild(ne);
    //    setTimeout(function () {
    //        document.querySelector(".da").querySelector(".envelope").classList.add("fold");

    //        setTimeout(function () {
    //            document.querySelector(".da").remove();
    //        }, 5000);
    //    }, 3000);
    //    //location.reload();
    //});
    //srCon.invoke("BroadcastMessage", "<strong>" + document.title + "</strong> at " + (new Date().toString())).catch(function (err) {
    //    return console.error(err.toString());
    //});
}).catch(function (err) {
    let srs = document.getElementById("sigrStatus");
    srs.className = "srs fail";
    srs.title = "Failed to connect to SignalR Server";
    return console.error(err.toString());
});

function toggleEnvelop(divItem) {
    divItem.classList.toggle("fold");
    document.querySelector(".da").querySelector(".envelope").classList.add("fold");
}

function closePopup() {
    document.querySelector(".da").remove();
}

/*-*-*-*-*-*-*-*-*-*-*-*-*-*- SignalR till here -*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/
